import { useMutation, useQuery } from "@apollo/client";
import { meGQL, updateUserMetadataGQL } from "../graphql";
import { FeaturedCard, Query, User } from "@onmo/graphql/graphql";

const MAX_ITEMS = 10;

const updateRecentlyPlayed = (
  currentList: FeaturedCard[],
  newGame: FeaturedCard,
): FeaturedCard[] => {
  const list = currentList || [];
  const filteredList = list.filter((card) => card.id !== newGame.id);
  const updatedList = [newGame, ...filteredList];
  return updatedList.slice(0, MAX_ITEMS);
};

export const useUpdateRecentlyPlayed = () => {
  const { data: dataMe } = useQuery<{ me: Query["me"] }>(meGQL);
  const [updateUserMetadata] = useMutation(updateUserMetadataGQL);

  const updateProducts = (game: FeaturedCard) => {
    if (!dataMe || !dataMe?.me?.metadata) {
      return;
    }

    const currentProducts = dataMe.me.metadata.tgpRecentlyPlayed;
    const newRecentlyPlayed = updateRecentlyPlayed(currentProducts, game);

    try {
      updateUserMetadata({
        variables: {
          input: {
            tgpRecentlyPlayedItems: newRecentlyPlayed.map((card) => card.id),
          },
        },
        update(cache) {
          const existing = cache.readQuery<{ me: User }>({ query: meGQL });
          if (!existing?.me) return;

          cache.writeQuery({
            query: meGQL,
            data: {
              me: {
                ...existing.me,
                metadata: {
                  ...existing.me.metadata,
                  __typename: existing.me.metadata?.__typename,
                  tgpRecentlyPlayed: newRecentlyPlayed,
                },
              },
            },
          });
        },
      });
    } catch (error) {
      console.error("Error updating recently played:", error);
    }
  };

  return { updateProducts };
};
